import { TemplateRef } from "@angular/core";

export class HelpDialogItem {
	header?: string;
	pictureUrl?: string;
	detailLink?: { text: string, link: string } | string;
	
	static of(base: HelpDialogItem['base']) {
		return new HelpDialogItem(base);
	}
	
	constructor(
		public base: string | TemplateRef<any>
	) {}
	
	setHeader(val?: string) {
		this.header = val;
		return this;
	}
	
	setPictureUrl(val?: string) {
		this.pictureUrl = val;
		return this;
	}
	
	setDetailLink(val?: string | { text: string, link: string }) {
		this.detailLink = val;
		return this;
	}
	
	detailLinkIsString() {
		return typeof this.detailLink === 'string';
	}
	
	baseIsTemplateRef() {
		return this.base instanceof TemplateRef;
	}
}

export interface HelpDialogUpdate {
	items: HelpDialogItem[]
	index?: number
	position?: 'top' | 'center' | 'bottom' | 'left' | 'right'
}